export const MORTGAGE_TYPES = Object.freeze({
  TITLE: "Title",
  LENDER: "Lender",
  UNDERWRITER: "Underwriter",
});
